module.exports = __webpack_public_path__ + "img/logo.ab2c9135.png";